import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideos = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28.9949 8.82373C28.9037 7.24892 27.5977 6 26 6H6L5.82373 6.00509C4.24892 6.09634 3 7.40232 3 9V23L3.00509 23.1763C3.09634 24.7511 4.40232 26 6 26H26L26.1763 25.9949C27.7511 25.9037 29 24.5977 29 23V9L28.9949 8.82373ZM6 8H26L26.1166 8.00673C26.614 8.06449 27 8.48716 27 9V23L26.9933 23.1166C26.9355 23.614 26.5128 24 26 24H6L5.88338 23.9933C5.38604 23.9355 5 23.5128 5 23V9L5.00673 8.88338C5.06449 8.38604 5.48716 8 6 8ZM13 12C13 11.2393 13.8074 10.771 14.4583 11.1108L14.5547 11.1679L20.5547 15.1679C21.1113 15.539 21.1461 16.329 20.6591 16.7525L20.5547 16.8321L14.5547 20.8321C13.9218 21.254 13.0843 20.842 13.0059 20.1118L13 20V12ZM15 18.13V13.869L18.196 16L15 18.13Z"
	})
});
export default SvgVideos;
